import { createAsyncThunk } from '@reduxjs/toolkit'

import * as api from 'connections/restApi'

export const get = createAsyncThunk('potentialCycles/get', async payload => {
  const response = await api.getPotential(payload)
  return response
})
